import HorizontalTabs from "common/HorizontalTabs";
import { Icon } from "common/Icon";
import { conversions as C } from "lib/units";
import React from "react";
import styles from "./embed.scss";

export default function RouteList({ routes, selectedRoute, onClick, metricUnits, hideDownload }) {
  const makeTab = (route) => {
    const node = (
      <RouteTab
        route={route}
        metricUnits={metricUnits}
        selected={selectedRoute === route.id}
        hideDownload={hideDownload}
      />
    );
    const key = route.id;
    const selected = route.id === selectedRoute;
    return { key, node, selected };
  };

  const routeTabs = routes.map(makeTab);

  const showAll = {
    key: -1,
    node: <div className={styles.ShowAll}>Show All</div>,
    width: 80,
  };

  const tabs = [...routeTabs, showAll];

  return <HorizontalTabs tabs={tabs} onClick={onClick} selected={selectedRoute} />;
}

function RouteTab({ route, metricUnits, selected, hideDownload }) {
  let distance, elevation;
  if (metricUnits) {
    distance = Math.round(route.distance / 1000) + " km.";
    elevation = Math.round(route.elevation_gain) + " m.";
  } else {
    distance = Math.round(C.metersToMiles(route.distance)) + " mi.";
    elevation = Math.round(C.metersToFeet(route.elevation_gain)) + " ft.";
  }
  return (
    <div className={styles.RouteTab}>
      <h3 title={route.name}>{route.name}</h3>
      <span className={styles.metric}>
        <Icon i="md-pin" /> {distance}
      </span>
      <span className={styles.metric}>
        <Icon i="md-add" /> {elevation}
      </span>
      {selected && (
        <div className={styles.RouteTabLinks}>
          <a href={`/routes/${route.id}`} target="_blank">
            View Full
          </a>
          {!hideDownload && (
            <>
              {" · "}
              <a href={`/routes/${route.id}/send_to_device`} target="_blank">
                Download
              </a>
            </>
          )}
        </div>
      )}
    </div>
  );
}
